export default {
  // モード
  "common.mode.auto": "自動モード（自家発電利用）",
  "common.mode.economy": "エコノミーモード",
  "common.mode.exigency": "緊急モード",

  // 機器
  "common.grid": "電力網",
  "common.evChargers": "電気自動車充電器（複数）",
  "common.evCharger": "電気自動車充電器",
  "common.pv": "太陽光発電（PV）",
  "common.inverter": "インバーター（電圧変換装置）",
  "common.pcs": "インバーター＋バッテリー",
  "common.terminal": "端末装置",
  "common.airc": "エアコン（AC）",
  "common.engine": "エンジン",
  "common.battery": "バッテリー",
  "common.metter": "電力メーター",
  "common.other": "その他",
  "common.power": "電力",
  "common.powerTotal": "総電力",
  "common.voltage": "電圧",
  "common.electricity": "電気",
  "common.current": "電流",
  "common.homeUsage": "総家庭負荷",
  "common.battery.power": "バッテリー電力",

  // データ
  "common.noDataAvailable": "現在データは利用できません~",
  "common.tips": "ヒント",
  "common.reset": "リセット",
  "common.currencyUnit": "¥（元）",
  "common.submiting": "送信中...しばらくお待ちください...",
  "common.close": "閉じる",
  "common.from": "から",
  "common.useIn": "まで",
  "common.energyPercent": "エネルギー利用率",
  "common.dataFlow": "データフロー",
  "common.getDataIng": "データ取得中...しばらくお待ちください...",
  "common.pageLoading": "ページ読み込み中...しばらくお待ちください...",
  "common.reseting": "ページリセット中...しばらくお待ちください...",
  "common.save": "保存",
  "common.onlyNumberTips": "数値のみ入力可能です",
  "common.offline": "オフライン",
  "common.online": "オンライン",
  "common.fault": "故障（問題）",
  "common.charge": "充電（バッテリー）",
  "common.discharge": "放電（バッテリー電力使用）",
  "common.buy": "購入",
  "common.sell": "売却",
  "common.loadingInfo": "読み込み中...しばらくお待ちください...",

  // 一般的な機能
  "common.moreFeatures": "その他の機能",
  "common.confirm": "確認",
  "common.saveing": "保存中...しばらくお待ちください...",
  "common.searchPlacholder": "検索キーワードを入力",
  "common.iSee": "わかりました",
  "common.pageErrorTips1": "おっと、ページでエラーが発生しました~",
  "common.pageErrorTips2": "ページを再読み込みするか、サポートに連絡してください~",
  "common.refresh": "再読み込み",
  "common.backToHome": "ホームページに戻る",
  "common.checkTips": "確認中...しばらくお待ちください...",
  "common.back": "戻る",
  "common.cancel": "キャンセル（削除）",
  "common.optional": "オプション（必須ではない）",
  "common.required": "必須",
  "common.status": "ステータス",
  "common.statusNoDelete": "未削除",
  "common.statusDelete": "削除済み",
  "common.submit": "送信",
  "common.disable": "無効化",
  "common.enable": "有効化",
  "common.year": "年",
  "common.month": "月",
  "common.day": "日",
  "common.version": "バージョン:",
  "common.backHome": "ホームページに戻る",
  "common.backHomeSorry": "申し訳ありません、このページは無効です",
  "common.requestTips1": "データ取得中です、再度送信しないでください",
  "common.requestTips2": "システムメッセージ",
  "common.requestTips3": "ログインセッションが期限切れです、再度ログインしてください",
  "common.requestTips4": "再度ログイン",
  "common.requestTips5": "ログインが無効またはセッションが期限切れです、再度ログインしてください。",
  "common.requestTips6": "サーバーエラーが発生しました。後で再試行してください。",
  "common.requestTips7": "システムリクエストがタイムアウトしました",
  "common.requestTips8": "システムインターフェース",
  "common.requestTips9": "エラー",
  "common.iknow": "わかりました",
  "common.logoutSuccess": "ログアウトに成功しました",
  
  // 詳細情報
  "common.knowMore.title": "詳細情報については、Beinengにお問い合わせください",
  "common.knowMore.email": "お問い合わせメール",
  "common.knowMore.phone": "お問い合わせ電話番号",
  "common.knowMore.wechat": "お問い合わせWeChat",
  "common.knowMore.website": "公式ウェブサイトURL",
  "common.knowMore.address": "お問い合わせ住所",
  "common.knowMore.addressDetail": "広東省東莞市黄江鎮黄牛埔村清渓8路5棟1301号1205室",
  
  // ローカル接続
  "common.localConnection": "ローカル接続",
  "common.operateInApp": "アプリ内で操作を実行してください！",
  
  "common.enbleStaus": "有効化状態",
  "common.battery.status": "充電せず、放電せず",

  // アカウント関連
  "account.forgetThePassword": "パスワードを忘れた",
  "account.logInDirectly": "直接ログイン",
  "account.tips1": "ページ遷移中...しばらくお待ちください...",
  "account.tips2": "まず利用規約を読んで同意してください！",
  "account.autoLogin": "自動ログイン",
  "account.userLogin": "ユーザーログイン",
  "account.registerTips": "アカウントがない場合は？こちらをクリックして登録",
  "account.userEmail": "ユーザー名 / メールアドレス",
  "account.userEmailTips": "ユーザー名またはメールアドレスを入力",
  "account.password": "パスワード",
  "account.passwordTips": "パスワードを入力",
  "account.submit": "送信",
  "account.submitTips": "送信中...しばらくお待ちください...",
  "account.otherLoginTips": "または他のログイン方法を選択",
  "account.userRegistration": "ユーザー登録",
  "account.userName": "ユーザー名",
  "account.userNameTips": "ユーザー名を入力",
  "account.emailTips1": "メールアドレスを入力",
  "account.emailTips2": "無効なメール形式",
  "account.phone": "電話",
  "account.phoneTips1": "電話番号を入力",
  "account.phoneTips2": "無効な電話番号",
  "account.phoneTips3": "電話番号を入力",
  "account.passwordTips1": "パスワードを入力（6-30文字）",
  "account.passwordTips2": "無効なパスワード形式：パスワードは英字、数字、アンダースコア（_）、ハイフン（-）、ピリオド（.）を含む必要があり、長さは6-12文字です",
  "account.passwordTips3": "入力された2つのパスワードが一致しません、確認して再度入力してください！",
  "account.passwordTips4": "パスワードを入力：パスワードは英字、数字、アンダースコア（_）、ハイフン（-）、ピリオド（.）を含む必要があります",
  "account.passwordTips5": "パスワード確認",
  "account.passwordTips6": "確認のためパスワードを入力",
  "account.passwordTips7": "入力された2つのパスワードが一致しません、確認して再度入力してください！",
  "account.passwordTips8": "確認のためパスワードを入力",
  "account.passwordTips9": "おめでとうございます、登録が完了しました！",
  "account.passwordTips10": "あなたのユーザー名は：",
  "account.emailIs": "あなたのメールアドレスは：",
  "account.goToLoginPage": "s秒後に自動的にログインページに遷移します",
  "account.goLogin": "ログイン",
  "account.goRegister": "登録",
  "account.loginSuccess": "ログインに成功しました",
  "account.email": "メール",
  "account.sologn": "あなたのために特別に設計された統合エネルギープラットフォームを提供します",
  "account.pleaseAgree": "利用規約を読み、同意します",
  "userAgreement.privacyPolicy": "プライバシーポリシー",

  // 検証コード関連
  "account.code": "検証コード",
  "account.codeTips": "検証コードを入力",
  "account.codeTips2": "無効な検証コード",

    "account.inviteCodeTips": "招待コードを入力してください",
    "account.inviteCodeHint": "招待コードを取得するには、設置業者または運用保守担当者にお問い合わせください",
  // パスワード変更と回復
  "account.modifyPasswordByAccount": "アカウント経由でパスワードを変更",
  "account.modifyPasswordByEmail": "メール経由でパスワードを変更",
  "account.getPasswordByAccount": "アカウント経由でパスワードを取得",
  "account.getPasswordByEmail": "メール経由でパスワードを取得",

  "account.sendEmailTips": "検証コードがメールに送信されました、確認してください",
  "account.name": "アカウント名",
  "account.newPassword": "新しいパスワード",
  "account.confirmNewPassword": "新しいパスワードの確認",
  "account.nameTips": "アカウント名を入力",
  "account.passwordModifySuccess": "パスワードの変更に成功しました",
  "account.emailCode": "メール検証コード",
  "account.emailCodeTips": "メール検証コードを入力",
  "account.emailCodeTips2": "無効なメール検証コード",
  "account.emailModifySuccess": "パスワードの変更に成功しました",
  "account.passworTips1": "あなたのパスワードがリセットされました！",
  "account.passwordTips11": "確認のためパスワードを入力",
  "account.passwordTips12": "新しいパスワードを入力",
  "account.nickname": "ニックネーム",
  "account.modifyNickname": "ニックネームを変更",
  "account.modifyNicknameSuccess": "ニックネームの変更に成功しました！",
  "account.nicknameTips": "ニックネームを入力",
  "account.nicknameError": "ニックネームの変更に失敗しました！",

  // クイック登録とログイン
  "account.login": "ログイン",
  "account.quickRegister": "クイック登録",
  "account.sendCode": "検証コードを送信",
  "account.sendTips": "s秒後に再送信可能",
  "account.sendEmailIng": "メール送信中...しばらくお待ちください...",
  "account.emailNotEmpty": "メールフィールドは空にできません",
  "account.registerAccount": "アカウント登録",
  "account.registerWelcome": "SusprSafe登録へようこそ",
  "account.usernameLimit": "ユーザー名は文字で始まる必要があり、文字、数字、アンダースコア（_）のみを含むことができ、長さは5-15文字です",

  // 著作権情報
  "copyright.desc2": "ウェブサイト登録情報：広東省ICP登録番号2021169764",

  // ユーザー情報編集
  "editUserInfo.editUserInformation": "ユーザー情報の編集",
  "editUserInfo.modifyUsername": "ユーザー名の変更",
  "editUserInfo.changePictures": "プロフィール画像の変更",
  "editUserInfo.savePicturesSuccess": "プロフィール画像の保存に成功しました",
  "editUserInfo.saveError": "保存に失敗しました",
  "editUserInfo.pictureLimit": "画像サイズは2MBを超えることができません",
  "editUserInfo.uploadPicture": "プロフィール画像のアップロード",
  "editUserInfo.picturePreview": "プレビュー",
  
  "editUserInfo.bindPhoneNumber": "電話番号のバインド",
  "editUserInfo.bindEmail": "メールのバインド",
  "editUserInfo.changePassword": "パスワードの変更",

  "editUserInfo.notificationSettings": "通知設定",
  "editUserInfo.editAccount": "アカウント情報の編集",
  "editUserInfo.waitBingting": "バインド中...しばらくお待ちください...",
  "editUserInfo.collapse": "折りたたむ（分離）",
  "editUserInfo.modifyBinding": "バインドの変更",
  
  "editUserInfo.emailAddress": "メールアドレス",
  "editUserInfo.tips1": "メールのバインドに成功しました",
  "editUserInfo.tips2": "保存に失敗しました",
  "editUserInfo.tips3": "メール検証コード送信中...しばらくお待ちください...",
  "editUserInfo.tips4": "検証コードがメールxxxxに送信されました、確認してください",
  "editUserInfo.tips5": "検証コードの送信に失敗しました！",
  "editUserInfo.tips6": "電話番号がバインドされました",
  "editUserInfo.tips7": "メールがバインドされました",
  "editUserInfo.emailTips1": "メールアドレスを入力",
  "editUserInfo.emailTips2": "無効なメール形式",
  "editUserInfo.emailTips3": "xxxx秒後に再送信可能",
  "editUserInfo.emailTips4": "検証コードを送信",
  "editUserInfo.emailTips5": "メール検証コードフィールドは空にできません",
  "editUserInfo.emailTips6": "無効なメール検証コード",
  "editUserInfo.emailCode": "メール検証コード",
  "editUserInfo.save": "保存",

  // 電話バインド関連
  "editUserInfo.phoneTips1": "電話番号のバインドに成功しました",
  "editUserInfo.phoneTips2": "SMS検証コード送信中...しばらくお待ちください...",
  "editUserInfo.phoneTips3": "SMS検証コードが番号xxxxに送信されました、確認してください",
  "editUserInfo.phoneTips4": "SMS検証コードの送信に失敗しました！",
  "editUserInfo.phoneTips5": "電話番号を入力",
  "editUserInfo.phoneTips6": "無効な電話番号形式",
  "editUserInfo.phoneTips7": "SMS検証コードを送信",
  "editUserInfo.phoneTips8": "SMS検証コード",
  "editUserInfo.phoneTips9": "SMS検証コードフィールドは空にできません",
  "editUserInfo.phoneTips10": "無効なSMS検証コード",
  "editUserInfo.phone": "電話番号",


  // 通知設定
  "editUserInfo.noticeTips1": "通知設定の取得に失敗しました！",
  "editUserInfo.noticeTips2": "通知設定の保存に成功しました！",
  "editUserInfo.noticeTips3": "バッテリー残量低下通知",
  "editUserInfo.noticeTips4": "充電完了通知",
  "editUserInfo.errorNotification": "エラー通知",
  "editUserInfo.updateNotification": "更新通知",
  "editUserInfo.monthlyStatisticsNotification": "月次統計通知",
  "editUserInfo.notificationMethod": "受信方法",

  // ユーザー名関連のヒント
  "editUserInfo.userNameTips1": "ユーザー名の保存に成功しました",
  "editUserInfo.userNameTips2": "ユーザー名の保存に失敗しました",
  "editUserInfo.userNameTips3": "ユーザー名を入力",
  "editUserInfo.userNameTips4": "無効なユーザー名形式：数字、アンダースコア（_）、英字のみを含むことができます",
  "editUserInfo.userNameTips5": "ユーザー名を入力",
  "editUserInfo.userNameTips6": "保存中...しばらくお待ちください...",
  "editUserInfo.userName": "ユーザー名",

  // プロフィール画像編集ヒント
  "editUserInfo.avatorTips": "プロフィール画像を変更するにはクリック",
  "editUserInfo.verifyCodeTips1": "受け取った検証コードを入力してください：",
  "editUserInfo.verifyCodeTips2": "アカウントの安全性のため、以下のボタンをクリックして元の電話番号に検証コードを送信してください：",
  "editUserInfo.verifyCodeTips3": "検証コードを送信",
  "editUserInfo.verifyCodeTips4": "元の電話番号の検証に成功しました、バインドする新しい電話番号を入力してください",
  "editUserInfo.verifyCodeTips5": "アカウントの安全性のため、以下のボタンをクリックして元のメールに検証コードを送信してください：",
  "editUserInfo.verifyCodeTips6": "元のメールの検証に成功しました、新しいメールを入力してください",
  "editUserInfo.verifyCodeTips7": "古いパスワード",
  "editUserInfo.verifyCodeTips8": "まず、メールをバインドしてください！",
  "editUserInfo.verifyCodeTips9": "検証コードがメールに送信されました、確認してください",
  "editUserInfo.verifyCodeTips10": "、自動的にログインページに遷移します",

  // 通知関連
  "hems.notice.title": "通知タイトル", 
  "hems.notice.content": "通知内容", 
  "hems.notice.operate": "操作",
  "hems.notice.noRead": "未読",
  "hems.notice.read": "既読",
  "hems.notice.warning": "警告",
  "hems.notice.error": "エラー",
  "hems.notice.success": "統計計算",
  "hems.notice.sys": "システム情報",
  "hems.notice.operateSuccess": "操作に成功しました",
  "hems.notice.operateTips": "操作する要素を選択してください",

  // ホームページ
  "hems.home.selfuseRate": "自家利用率",
  "hems.home.percent": "パーセント",
  "hems.home.todayData": "今日のデータ",
  "hems.home.todayPowerGeneration": "今日の発電量",
  "hems.home.salesIncome": "電力販売収入",
  "hems.home.saved": "節約しました",
  "hems.home.reduce": "炭素排出量削減",
  "hems.home.tips1": "現在データは利用できません、まだxxxxをバインドしていません",
  "hems.home.criticalLoad": "重要負荷",
  "hems.home.keyVoltage": "重要電圧",
  "hems.home.householdLoad": "家庭負荷",
  "hems.home.householdVoltage": "家庭電圧",
  "hems.home.generalLoad": "一般負荷",
  "hems.home.generalVoltage": "一般電圧",
  "hems.home.batteryHealth": "バッテリー健康状態",
  "hems.home.averageTemp": "平均温度",
  "hems.home.gridLoad": "電力網負荷",
  "hems.home.toggeleDataSource": "表示されているデータは以下のように変更されました：",
  "hems.home.toggleTips": "変更しますか？",
  "hems.home.modeSending": "モードコマンド送信中...しばらくお待ちください...",
  "hems.home.modeSuccess": "モード変更が正常に送信されました！",
  "hems.home.isOnline": "オンラインですか？",
  "hems.home.useStatus": "使用状況",
  "hems.home.workModeText": "現在の動作モード：",
  "hems.home.toggleDataSourceText": "表示されているデータは以下のように変更されました：",
  "hems.ev.charge.status": "充電状態",
  "hems.ev.charge.time": "充電時間",
  "hems.ev.charge.count": "実際の充電回数（時間経過）",
  "hems.ev.charge.status.empty": "空",
  "hems.ev.charge.status.ing": "バッテリーに接続中。充電中",
  "hems.ev.charge.status.null": "バッテリーに接続中、但し充電中ではない",
  "hems.ev.charge.status.error": "エラー",
  "hems.hour": "時間",
  "hems.minue": "分",
  "hems.ev.chagre.number": "充電器番号",

  // ユーザーガイド
  "hems.userGuide.selfUse": "自家発電利用",
  "hems.userGuide.selfUseTips": "まず太陽光エネルギーを使用し、不足している場合は電力網で補充",
  "hems.userGuide.economyMode": "エコノミーモード",
  "hems.userGuide.economyModeTips": "電気料金に基づいてエネルギー使用戦略を最適化",
  "hems.userGuide.emergencyMode": "緊急モード",
  "hems.userGuide.emergencyModeTips": "重要負荷への電力供給を優先",

  // グラフページ
  "hems.history.energyStatistics": "エネルギー統計",
  "hems.history.revenueStatistics": "収入統計",
  "hems.history.greenStatistics": "グリーン排出量削減",
  "hems.history.revenueTitle": "電力販売総収入",
  "hems.history.savingsTitle": "総節約額",
  "hems.history.carbonTitle": "総炭素削減量",
  "hems.history.day": "日",
  "hems.history.month": "月",
  "hems.history.year": "年",
  "hems.history.beforeDay": "前日",
  "hems.history.afterDay": "翌日",
  "hems.history.beforeMonth": "前月",
  "hems.history.afterMonth": "翌月",
  "hems.history.beforeYear": "前年",
  "hems.history.afterYear": "翌年",
  "hems.history.totalUse": "総使用量",
  "hems.history.fullScreen": "全画面",
  "hems.history.timeSelect": "日付を選択",
  "sync.tips1": "データ同期コマンドが正常に送信されました！",
  "sync.tips2": "データ量が多いためデータ同期に時間がかかります、50分後に再度確認してください~",
  "sync.tips3": "データの不一致が見られる場合は、デバイスのデータ同期が遅れている可能性があります、以下のボタンをクリックしてください：",
  "sync.tips4": "データを同期",

  // 充電器情報
  "charge.info": "充電器情報",
  "news.loading": "読み込み中...",
  "news.noMore": "これ以上データはありません",
  "hems.pv.power": "太陽光エネルギー量",

  // UEH固有機能
  "ueh.sellPower": "販売電力量",
  
  // メニュー
  "menu.home": "ホームページ",
  "menu.history": "履歴データ",
  "menu.device": "デバイス",
  "menu.settings": "設定",
  "menu.messageCenter": "メッセージセンター",
  "menu.help": "ヘルプとサポート",
  "menu.mine": "自分（個人）",


  // マイ設定
  "mine.userSetting": "ユーザー設定",
  "mine.terminalSetting": "基本端末設定",
  "mine.uploadCloud": "データをクラウドにアップロード",
  "mine.changeVersion": "更新を確認",
  "mine.language": "言語を切り替え",
  "mine.about": "アプリについて",
  "mine.feedback": "フィードバック",
  "mine.logout": "ログアウト",
  "mine.logoutAccount": "アカウントを削除",

  // アカウント削除関連
  "mine.logoutAccountTips": "名前[]のアカウントを削除",
  "mine.logoutAccountTips1": "[]にバインドされたアカウントを削除",
  "mine.logoutAccountCare": "アカウント削除リクエストの注意事項：",
  "mine.logoutAccountCare1": "1. アカウントは安全な状態にあります",
  "mine.logoutAccountCare1-1": "アカウントは通常の使用状態にあり、盗難、規約違反、または閉鎖のリスクはありません",
  "mine.logoutAccountCare2": "2. アカウントアクセスとバインドが削除されます",
  "mine.logoutAccountCare2-1": "サードパーティプラットフォームへのすべてのアカウントアクセス権が削除されます",
  "mine.logoutAccountCare3": "3. 削除後はアカウントを復元できません、ユーザーデータが削除されます",
  "mine.logoutAccountCare3-1": "削除後、バインドされている電話番号、メール、関連データが削除され、復元できません",
  "mine.confirmLogout": "削除を確認",
  "mine.logoutSuccess": "アカウントが正常に削除されました！",


  // フィードバック問題
  "mine.feedbackIssues": "問題とフィードバック",
  "mine.feedQuantity": "数量",
  "mine.feedAmount": "最大9枚の画像、1枚あたりの最大サイズ1MB",

  // 通知設定関連
  "mine.notice.fail": "通知設定の取得に失敗しました！",
  "mine.notice.saveSuccess": "通知設定の保存に成功しました！",
  "mine.notice.saveFail": "保存に失敗しました！",
  "mine.notice.title": "通知設定",
  "mine.notice.batteryLow": "バッテリー残量低下通知",
  "mine.notice.chargingFinish": "充電完了通知",
  "mine.notice.error": "エラー通知",
  "mine.notice.update": "更新通知",
  "mine.notice.monthly": "月次統計通知",
  "mine.notice.receiveType": "受信方法",

  // 言語設定へようこそ
  "mine.language.welcome": "SusprSafeへようこそ",
  "mine.language.desc1": "自宅の場所に応じて言語バージョンを選択してください",
  "mine.language.desc2": "アプリの設定でいつでも切り替えることができます",

  // 個人情報
  "mine.userInfo.avatar": "プロフィール画像",
  "mine.userInfo.nickname": "ニックネーム",
  "mine.userInfo.password": "パスワード",
  "mine.userInfo.changePassword": "パスワードを変更",
  "mine.userInfo.setPassword": "パスワードを設定",
  "mine.userInfo.phoneNumber": "電話番号",
  "mine.userInfo.bindPhone": "電話をバインド",
  "mine.userInfo.bindEmail": "メールをバインド",
  "mine.loginExpired": "ログインセッションが期限切れです、再度ログインしてください",
  "mine.userInfo.title": "ユーザー情報",
  "mine.userInfo.bind": "バインド",
  "mine.userInfo.modify": "修正",
  "mine.userInfo.modifyNickname": "ニックネームを変更",
  "mine.userInfo.userNickname": "ユーザーニックネーム",
  "mine.userInfo.selectPic": "アップロードする画像を選択",
  "mine.userInfo.saveSuccess": "保存に成功しました",
  "mine.userInfo.uploadFail": "アップロードに失敗しました",
  "mine.userInfo.avatarSaveSuccess": "プロフィール画像の保存に成功しました",
  "mine.userInfo.nameTips1": "ニックネームフィールドは空にできません",
  "mine.userInfo.nameTips2": "ニックネームを入力",

  // 一般的な選択ヒント
  "common.pleaseSelect": "選択してください",
  "question.commonQuestions": "よくある質問",
  "account.toggleLanguage": "言語を切り替え",
  "account.localConnection": "ローカル接続",
  "account.selectLanguage": "言語を選択してください",
  "account.sendEmailToast": "検証コードがメールxxxに送信されました、確認してください",
  "account.emailError": "無効なメール形式",
  "account.sendEmailFail": "送信に失敗しました、再度試してください",
  
  "common.submitting": "送信中...しばらくお待ちください...",

  "device.page.noData": "現在データは利用できません、このページはアプリ内でのみ表示できます",

  // OTA Upgrade
  "bmsFirmware.upgrade": "アップグレード",
  "bmsFirmware.upgrading": "アップグレード中...",
  "bmsFirmware.uploadingFile": "ファームウェアファイルをアップロード中...",
  "bmsFirmware.upgradingProgress": "ファームウェアをアップグレード中... {progress}%",
  "bmsFirmware.upgradeSuccess": "アップグレード成功",
  "bmsFirmware.upgradeSuccessSubtitle": "BMSファームウェアのアップグレードが完了しました！",
  "bmsFirmware.upgradeFailed": "アップグレード失敗",
  "bmsFirmware.upgradeFailedFormError": "フォームの入力が正しいかを確認してください",
  "bmsFirmware.upgradeFailedNetworkError": "ネットワークエラー、再試行してください",
  "bmsFirmware.invalidFileType": "有効なファームウェアファイルを選択してください (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "まずファームウェアファイルを選択してください",
  "bmsFirmware.statusUpgrading": "アップグレード中",
  "bmsFirmware.statusCompleted": "アップグレード完了",
  "bmsFirmware.statusFailed": "アップグレード失敗",
  "bmsFirmware.deviceUpgrading": "ファームウェアパッケージをアップグレード中、アップグレードには30～50分かかります。この間、デバイスのリアルタイムデータを表示できません。お待ちください...",
  "bmsFirmware.upgradeStatusLabel": "アップグレード状態",
  "bmsFirmware.upgradeProgressLabel": "アップグレード進行状況",
  "bmsFirmware.currentPackageLabel": "現在送信済みのデータパッケージ番号",
  "bmsFirmware.totalPackagesLabel": "総データパッケージ数",
  "bmsFirmware.upgradeFailedCheckDevice": "デバイスの状態を確認し、アップグレードを再試行してください",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "設定成功",
  "settingResult.defaultSubTitle": "パラメータ設定が保存されました",
  "settingResult.confirmButton": "OK"
};
